/* @ngInject */
const myEnter = () => {
  return {
    restrict: 'A',
    scope: {},
    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => {
        element.bind('keydown keypress', function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.myEnter)
            })

            event.preventDefault()
          }
        })
      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}
export default myEnter



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/myEnter.js